import Chip from "@material-ui/core/Chip";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { instance } from "Actions/AxiosInstance";
import infoIcon from "Assets/newicons/notify/info/outline/info-outline-16px.svg";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import "./index.scss";

class Jobdescription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // step: 1,
      // AllDesignation: [],
      // postData: this.props.postData,
      // currency: [],
      // budgettypes: [
      //     { displayvalue: "1", displayname: "Annual" },
      //     { displayvalue: "2", displayname: "Monthly" },
      //     { displayvalue: "3", displayname: "Weekly" },
      // ],
      // grades: [],
      designationData: [],
      // designationid: this.props.designationid,
      expanded: true,
    };

    this.getData = this.getData.bind(this);
    // this.handleChange = this.handleChange.bind(this);
    // this.onSaveDraft = this.onSaveDraft.bind(this);
  }

  async componentDidMount() {
    //  this.getData();
  }

  getData(item) {
    instance
      .get(`subscription/designation/${item.designationid}`)
      .then((response) => {
        this.setState({
          designationData: response.data.result && response.data.result[0],
        });
      });
  }

  handleExpandClick = (panel) => (event, isExpanded) => {
    isExpanded
      ? this.setState({ expanded: panel })
      : this.setState({ expanded: false }); // new state manager//
  };

  render() {
    const { postData } = this.props;
    const { designationData } = this.state;
    return (
      <div className="position-rel" style={{ width: "calc(100% - 300px)" }}>
        <div className="job-details-wrapper position-rel">
          <img
            src={infoIcon}
            style={{ verticalAlign: "middle" }}
            onMouseOver={() => this.getData(postData)}
            onMouseLeave={() => this.setState({ designationData: [] })}
          ></img>
          <Paper className="job-details rounded-rectangle-paper padding16">
            <p className="small-dark-secondary t-bold margin-bottom-4">
              Job mission
            </p>

            <p className="small-dark-secondary margin-bottom-8">
              {designationData.mission
                ? designationData.mission
                : "No job mission defined"}
            </p>

            <Grid container spacing={2}>
              <Grid item sm={12} md={6}>
                {designationData.rolesummary ? (
                  <ExpansionPanel
                    // expanded={this.state.expanded === "panel1"}
                    expanded={this.state.expanded}
                    // onChange={this.handleExpandClick("panel1")}
                    className="rounded-rectangle-paper rounded-rectangle-div padding0"
                  >
                    <ExpansionPanelSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <p
                        className="small-dark-secondary t-bold"
                        style={{ lineHeight: "24px" }}
                      >
                        Role summary
                      </p>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      {designationData.rolesummary && (
                        <p className="small-dark-secondary">
                          {" "}
                          {designationData.rolesummary &&
                            designationData.rolesummary}
                        </p>
                      )}
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                ) : (
                  <div>
                    <p className="small-dark-secondary t-bold margin-bottom-4">
                      Role summary
                    </p>
                    <p className="small-dark-secondary margin-bottom-8 ">
                      No role summary defined
                    </p>
                  </div>
                )}
                {designationData.responsibility ? (
                  <ExpansionPanel
                    // expanded={this.state.expanded === "panel2"}
                    expanded={this.state.expanded}
                    // onChange={this.handleExpandClick("panel2")}
                    className="rounded-rectangle-paper rounded-rectangle-div padding0 margin-top-16"
                  >
                    <ExpansionPanelSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2bh-content"
                      id="panel2bh-header"
                    >
                      <p
                        className="small-dark-secondary t-bold"
                        style={{ lineHeight: "24px" }}
                      >
                        Responsibilities
                      </p>
                    </ExpansionPanelSummary>
                    {/* <ExpansionPanelDetails
                                                className="display-block"
                                                style={{ padding: "0px 0px 16px 18px" }}
                                            >
                                                <ul style={{ margin: 0, paddingLeft: 24 }}>
                                                    <li>
                                                        <p className="small-dark-secondary">
                                                            Responsibility 1
                                </p>
                                                    </li>
                                                    <li>
                                                        <p className="small-dark-secondary">
                                                            Responsibility 2
                                </p>
                                                    </li>
                                                </ul>
                                            </ExpansionPanelDetails>
                                        */}

                    <ExpansionPanelDetails>
                      <p className="small-dark-secondary">
                        {" "}
                        {designationData.responsibility &&
                          designationData.responsibility.replace(
                            /(<([^>]+)>)/gi,
                            "",
                          )}{" "}
                      </p>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                ) : (
                  <div>
                    <p className="small-dark-secondary t-bold margin-bottom-4">
                      Responsibilities
                    </p>
                    <p className="small-dark-secondary">
                      No responsibilities defined
                    </p>
                  </div>
                )}
              </Grid>
              <Grid item sm={12} md={6}>
                <p className="small-dark-secondary t-bold margin-bottom-4">
                  Skills
                </p>
                {designationData.skill ? (
                  designationData.skill.map((x) => (
                    <Chip
                      variant="outlined"
                      label={x}
                      className="margin-right-8 margin-bottom-8"
                    />
                  ))
                ) : (
                  <p className="small-dark-secondary">No skills defined</p>
                )}
              </Grid>
            </Grid>
          </Paper>
        </div>
      </div>
    );
  }
}
export default withSnackbar(Jobdescription);
